import { ActiviteVersCompetenceAvecPrioriteComponent } from "./ActiviteVersCompetenceAvecPriorite";
import { Link } from 'react-router-dom';

export const CompetenceDeterminanteComponent = () => <ActiviteVersCompetenceAvecPrioriteComponent controllerNaming={"determinante"} textNaming={"déterminante"} infoDiv={<>Vous pouvez remplir ici les compétences déterminantes<br /> Lorsqu'aucune activité n'est trouvée, l'activité est déterminée par les compétences déterminantes qui sont compétences bloquantes de l'appel d'offre.<br/> Pour faire des updates par paquet cela se passe <Link to="/config/mergecompetencedeterminante">ici</Link></> } />



